import React, { useState } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import "./index.scss";
import { IconSearch } from "../../../../assets/icons/IconSearch";
import FilterDropdown from "../FilterDropdown";

const SearchFilterBar = ({ onSearch, onFilter, fields }) => {
  const [showFilter, setShowFilter] = useState(false);

  return (
    <div className="search-filter-wrapper position-relative m-4">
      <div className="d-flex justify-content-between">
        <InputGroup>
          <InputGroup.Text>
            <IconSearch />
          </InputGroup.Text>
          <Form.Control
            placeholder="Rechercher"
            onChange={(e) => onSearch(e.target.value)}
          />
        </InputGroup>

        <Button
          className="d-flex align-items-center btn-filter"
          onClick={() => setShowFilter(!showFilter)}>
          <FaFilter className="me-1" /> Filter
        </Button>
      </div>

      {showFilter && (
        <div className="filter-container position-absolute end-0 mt-2">
          <FilterDropdown
            fields={fields}
            onApply={(filters) => {
              onFilter(filters);
              setShowFilter(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default SearchFilterBar;
